<div class="h-full flex flex-col text-white border-neutral-600 scrollbar-dark">
  <div
    class="grid grid-cols-[auto_1fr_auto] gap-2 items-center border-b border-neutral-600 py-6 px-4 dark"
  >
    <button
      (click)="onCloseClick()"
      class="flex flx-ds primary w-fit"
      icon="center"
      flxButton
      variant="text"
    >
      <i
        class="ph ph-arrow-left"
        flxIcon
      ></i>
    </button>

    <span class="font-bold text-xl leading-8"
      >Choose {{ label() }} from {{ selectedDocument()?.name }}</span
    >
  </div>

  <div class="flex-1 min-h-0 flex flex-col">
    <div class="text-white text-xs pb-2 px-6 pt-4">
      The document you have selected contains references to multiple processes. Choose one to
      implement an execution plan from:
    </div>

    <div class="flex flex-col overflow-y-auto gap-2 px-6 pb-4">
      @for (resource of resources(); track resource.name) {
        <div class="flex flex-col gap-1 bg-black rounded-lg p-3 w-full">
          <div class="text-white text-xs font-semibold">{{ resource.name }}</div>
          <div class="text-white text-xs">{{ resource.description }}</div>

          <div class="flex flex-row items-center justify-between mt-1">
            <button
              (click)="onResourceClick(resource)"
              class="text-yellow-500 bg-yellow-900 enabled:hover:bg-yellow-800 text-white px-2 py-1.5 flex items-center gap-1.5 rounded-lg text-xs seft-start"
              flxButton
              type="button"
            >
              <i class="ph ph-sparkle"></i>
              {{
                type() === AiDocumentContentType.BUSINESS_PROCESS ? 'Generate Plan' : 'Implement'
              }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
